module.exports = __webpack_public_path__ + "media/images/about-us/about-bg-964ee7055c941b13bf8b96629e8d0389.jpg";